import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { INCIDENCIA_STEPS_API } from "../../../../../shared/services/incidenciasSteps";
import AutocompleteDynamic from "../../../../../shared/components/AutocompleteDynamic";

export default function StepForm({step, onCancel, onActionDone}) {
    const dispatch = useDispatch();
    const tipoIncidencias = useSelector(state => {
        const { tipo_incidencias } = state;
        return tipo_incidencias;
    });
    const { register, formState: { errors }, handleSubmit, reset, setValue } = useForm({
        defaultValues: {
            id: 0,
            nombre: '',
            step: 1,
            owner: '',
            solucion: 0,
            tipo_incidencia_id: -1,
            respuestas: ''
        }
    });

    useEffect(() => {
        reset(step);
    }, [step]);

    const handleChangeTipoIncidencia = (e) => { setValue('tipo_incidencia_id', parseInt(e.target.value)); }

    const handleChangeRespuestas = (respuestas) => { 
        setValue('respuestas', respuestas); 
    }

    const handleSubmitTarifa = async(data, e) => {
        e.preventDefault();
        dispatch({type: 'loading/set', payload: true});
        let response;

        if(!data?.respuestas || data?.respuestas.length === 0) {
            dispatch({type: 'loading/set', payload: false});
            return toast.error('Debes añadir al menos una respuesta. Busca y/o añade una respuesta y pulsa Enter.')
        }

        data.respuestas = data.respuestas.map(r => `"${r}"`).join(',');
        data.tipo_incidencia_id = parseInt(data.tipo_incidencia_id) === -1 ? null : data.tipo_incidencia_id;
        
        if(step) {
            response = await INCIDENCIA_STEPS_API.update(data);
        } else {
            response = await INCIDENCIA_STEPS_API.new(data);
        }

        if(response && response.success) {
            dispatch({type: 'loading/set', payload: false});
            toast.success(response.message);
            onActionDone();
        }
    }

    const handleCancel = () => onCancel(step ? 'edit' : 'new');
    
    return (
        <div className="w-100 d-flex flex-column mt-4">
            <form className="form align-items-center mb-4" onSubmit={handleSubmit(handleSubmitTarifa)}>
                <input 
                    type="hidden" 
                    {...register("id")} 
                    defaultValue={step ? step.id : ''} />

                <div className="w-100 d-flex flex-column flex-grow-1">
                    <div className="form-group flex-grow-1">
                        <label htmlFor="nombre">Nombre</label>
                        <input 
                            type="text" 
                            className="form-control"
                            {...register("nombre", { required: true })} 
                            defaultValue={step ? step.nombre : 0} />
                        
                        <div className="form-invalid">
                            {errors.nombre?.type === 'required' && "Nombre es obligatorio"}
                        </div>
                    </div>

                    <div className="form-group flex-grow-1">
                        <label htmlFor="nombre">Paso</label>
                        <input 
                            type="number" 
                            step={1}
                            className="form-control"
                            {...register("step", { required: true })} 
                            defaultValue={step ? step.step : 1} />
                        
                        <div className="form-invalid">
                            {errors.nombre?.type === 'required' && "Nombre es obligatorio"}
                        </div>
                    </div>

                    <div className="form-group flex-grow-1">
                        <label htmlFor="tipo" className="me-3">Tipo</label>
                        <div className="d-flex align-items-center mt-2">
                            <div className="me-3">
                                <input
                                    {...register("owner", { required: true })}
                                    type="radio"
                                    name="owner"
                                    value={"cliente"}
                                    id="owner"
                                    required
                                />
                                &nbsp; Cliente
                            </div>

                            <div>
                                <input
                                    {...register("owner", { required: true })}
                                    type="radio"
                                    name="owner"
                                    value={"proveedor"}
                                    id="owner"
                                    required
                                />
                                &nbsp; Proveedor
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="tipo_incidencia_id">Tipo de incidencia (opcional)</label>
                        <select 
                            {...register("tipo_incidencia_id", {required: true})}
                            defaultValue={step ? parseInt(step.tipo_incidencia_id) : -1}
                            onChange={handleChangeTipoIncidencia}>
                            <option key={'tipo-incidencias-0'} value={-1}>Todas</option>
                            {tipoIncidencias?.map(op => <option key={'tipo-incidencias-' + op.id} value={op.id}>{op.nombre}</option>)}
                        </select>
                    </div>

                    <div className="form-group flex-row align-items-center">
                        <label className="m-0 me-3">Solución:</label>

                        <input 
                            type="checkbox"
                            {...register("solucion")}
                            name={`solucion`}
                            defaultChecked={step ? step.solucion : false} />
                    </div>

                    <div className="form-group">
                        <label className="m-0 me-3">Respuestas:</label>

                        <AutocompleteDynamic 
                            options={step?.respuestas ? step?.respuestas : []}
                            id={"respuestas"}
                            selectedValues={step?.respuestas ? step?.respuestas : []}
                            onSetValue={handleChangeRespuestas}
                        />
                    </div>
                </div>

                <div className="d-flex align-items-center align-self-end ms-3 mt-4">
                    <button type="submit" className="btn btn-primary align-self-end">Guardar</button>
                    <button type="button" className="btn btn-default align-self-end ms-3" onClick={handleCancel}>Cancelar</button>
                </div>
            </form>
        </div>
    )
}